import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFAChevronRight = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='chevron-right'
          role='img'
          viewBox='0 0 320 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='chevron-right'
          role='img'
          viewBox='0 0 256 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='chevron-right'
          role='img'
          viewBox='0 0 256 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFAChevronRight.defaultProps = {
  variant: ICON_FA_VARIANT_REGULAR
}

IconFAChevronRight.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
